"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var $dyn;
(function ($dyn) {
    var ui;
    (function (ui) {
        /**
         * The base container control.
         */
        var Container = /** @class */ (function (_super) {
            __extends(Container, _super);
            function Container() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            Container.prototype.init = function (data, element) {
                _super.prototype.init.call(this, data, element);
                if (this.element) {
                    var containerId = this.element.getAttribute("data-dyn-container");
                    if (containerId !== "true") {
                        this.element.dynLayoutContainer = $(this.element).find(containerId)[0];
                    }
                }
                this.LayoutArrangeMethod = $dyn.ui.autoProperty($dyn.layout.ArrangeMethod.vertical, this, "ArrangeMethod");
            };
            /**
             * Sets focus to the first focusable control in the container.
             * @returns The control that was found to focus, if there is one.
             */
            Container.prototype.setChildControlFocus = function () {
                // Find the first focusable child control
                var childToFocus = $dyn.util.findFirstFocusableControl(this.element);
                // Call setFocus with the parent form for this container as the root.
                if (childToFocus) {
                    this.setFocus(childToFocus, this.Root);
                    return childToFocus;
                }
            };
            return Container;
        }($dyn.ui.Control));
        ui.Container = Container;
        // Set default values for the Container control
        // Default values are set here because init() is run from the constructor of $dyn.ui.Control before the derived class properties are initialized
        Container.prototype.Columns = 1;
        Container.prototype.ArrangeMethod = $dyn.layout.ArrangeMethod.vertical;
        Container.prototype.isContainer = true;
    })(ui = $dyn.ui || ($dyn.ui = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=Container.js.map
